'use strict';

var _ = require('lodash');
var ChartPricingDepartureDatesDataProviderService = function ChartPricingDepartureDatesDataProviderService($q, momentService, pricingDateChartGapsService, pricingAnalysisCommonsDataService, legendFilterService) {
  function aggregate(dataGrouped) {
    var basic = {
      departureDateMoment: dataGrouped[0].departureDate,
      eventTimeStampMoment: dataGrouped[0].eventTimeStamp,
      created: dataGrouped[0].departureDate,
      carrier: dataGrouped[0].carrier,
      market: dataGrouped[0].market,
      pos: dataGrouped[0].pos,
      cabin: dataGrouped[0].cabinCode,
      numberOfRecommendations: 0,
      numberOfEffectedServices: 0,
      numberOfEffectedServicesNew: 0,
      numberOfEffectedServicesExcluded: 0,
      numberOfEffectedServicesExtensions: 0,
      sumAvgFareChange: 0,
      selected: true,
      isGap: false
    };
    return _.reduce(dataGrouped, function (result, value) {
      result.sumAvgFareChange += value.averageFareChange;
      result.numberOfRecommendations += value.numberOfRecommendations;
      result.numberOfEffectedServices += value.numberOfEffectedServices;
      result.numberOfEffectedServicesNew += value.numberOfEffectedServicesNew;
      result.numberOfEffectedServicesExcluded += value.numberOfEffectedServicesExcluded;
      result.numberOfEffectedServicesExtensions += value.numberOfEffectedServicesExtensions;
      return result;
    }, basic);
  }
  function prepareChartData(chartObj, groupedDataSize) {
    var averageFareChange = _.round(chartObj.sumAvgFareChange / groupedDataSize, 2);
    chartObj.m1 = averageFareChange;
    chartObj.m2 = chartObj.numberOfRecommendations;
    chartObj.m3 = chartObj.numberOfEffectedServices;
    chartObj.m4 = chartObj.numberOfEffectedServicesExcluded;
    chartObj.circles = [{
      value: chartObj.m3,
      css: 'm3-circle'
    }, {
      value: chartObj.m4,
      css: 'm4-circle'
    }];
    delete chartObj.sumAvgFareChange;
    delete chartObj.numberOfRecommendations;
    delete chartObj.numberOfEffectedServices;
    delete chartObj.numberOfEffectedServicesExcluded;
    return chartObj;
  }
  function aggregateToChartData(data) {
    return _.chain(data).groupBy('departureDate').map(function (dataGrouped) {
      var chartObj = aggregate(dataGrouped);
      return prepareChartData(chartObj, dataGrouped.length);
    }).sortBy('departureDateMoment').value();
  }
  function transform(priceRecommendations) {
    var priceRecommendationsData = {
      data: [],
      originalDepartureDates: []
    };
    var chartData = aggregateToChartData(priceRecommendations);
    priceRecommendationsData.data = pricingDateChartGapsService.fillGaps(chartData, 'departureDateMoment', ['carrier', 'market', 'pos', 'cabin']);
    priceRecommendationsData.originalDepartureDates = _.map(priceRecommendations, function (data) {
      return data.departureDate;
    });
    return priceRecommendationsData;
  }
  function groupByMarket(priceRecommendations) {
    var marketRecommendations = _.groupBy(priceRecommendations, 'market');
    legendFilterService.setFilters(marketRecommendations);
    return marketRecommendations;
  }
  function filter(priceRecommendations) {
    var marketRecommendations = _.get(priceRecommendations, [legendFilterService.getSelectedMarket()], []);
    marketRecommendations = _.filter(marketRecommendations, {
      pos: legendFilterService.getSelectedPos(),
      cabinCode: legendFilterService.getSelectedCabin(),
      direction: legendFilterService.getSelectedDirection()
    });
    return marketRecommendations;
  }
  function getPrddKey(prdd) {
    return [prdd.market, prdd.carrier, prdd.departureDate.format('YYYY-MM-DD'), prdd.cabinCode, prdd.direction].join('.');
  }
  function getDuplicateDepartureDatesData(departureDateData) {
    if (!departureDateData) {
      return null;
    }
    return _.chain(departureDateData).groupBy(function (prdd) {
      return getPrddKey(prdd);
    }).transform(function (result, data, prddKey) {
      var eventTimeStamps = _.chain(data).groupBy(function (departureDateData) {
        return departureDateData.eventTimeStamp.valueOf();
      }).keys().map(_.toInteger).sortedUniq().reverse().value();
      if (_.size(eventTimeStamps) > 1) {
        result[prddKey] = eventTimeStamps;
      }
      return result;
    }, {}).value();
  }
  function removeDuplicated(departureDateData) {
    var groupedByPRDDKey = getDuplicateDepartureDatesData(departureDateData);
    return _.filter(departureDateData, function (prdd) {
      var prddKey = getPrddKey(prdd);
      var duplicateData = groupedByPRDDKey[prddKey];
      if (!duplicateData) {
        return true;
      }
      return prdd.eventTimeStamp.valueOf() === _.first(duplicateData);
    });
  }
  function getData() {
    return pricingAnalysisCommonsDataService.retrieveDepartureDatesChartData().then(removeDuplicated).then(groupByMarket).then(filter).then(transform);
  }
  function invalidateCache() {
    pricingAnalysisCommonsDataService.invalidateCache();
  }
  return {
    getData: getData,
    invalidateCache: invalidateCache
  };
};
ChartPricingDepartureDatesDataProviderService.$inject = ['$q', 'MomentService', 'PricingDateChartGapsService', 'PricingAnalysisCommonsDataService', 'PricingDepartureDatesLegendFilterService'];
module.exports = ChartPricingDepartureDatesDataProviderService;